import React, { useEffect } from 'react';
import './Toast.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

/**
 * Shared Toast component
 * - Supports `message` as either a string or an object with `{ title, action }`
 * - Optional `duration` (ms) and `onClose` callback
 * - `action.onClick` runs a handler instead of navigating to `action.url`
 * - `persistent` keeps it on screen (no timer, no close) until the caller removes it
 */
const Toast = ({ message, duration = 3000, onClose, persistent = false }) => {
  useEffect(() => {
    if (!onClose || persistent) return;

    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose, persistent]);

  if (!message) return null;

  const isObject = typeof message === 'object' && message !== null;
  const title = isObject ? message.title : message;
  const action = isObject && Object.prototype.hasOwnProperty.call(message, 'action')
    ? message.action
    : undefined;

  const actionElement = action
    ? React.createElement(
        'span',
        {
          onClick: () => {
            if (action?.onClick) {
              action.onClick();
            } else if (action?.url) {
              window.location.href = action.url;
            }
          },
          style: {
            color: action?.color,
            textDecoration: 'underline',
            fontWeight: 900,
            paddingLeft: '50px',
            cursor: 'pointer',
          },
        },
        action?.title
      )
    : null;

  const closeIconElement = React.createElement(FontAwesomeIcon, {
    icon: faXmark,
    size: 'lg',
    style: { color: '#ffffff', cursor: 'pointer', paddingLeft: '10px' },
  });

  return React.createElement(
    'div',
    { className: persistent ? 'toast toast--persistent' : 'toast', onClick: persistent ? undefined : onClose },
    title,
    ' ',
    actionElement,
    persistent ? null : closeIconElement
  );
};

export default Toast;

